import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import axios from "axios";

const SubscriptionPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    phone: "",
    countryCode: "+44",
  });

  //////////////////////////////////////////////////////
  // SHOW ONCE IN 12 HOURS
  //////////////////////////////////////////////////////

useEffect(() => {
  const subscribed = localStorage.getItem("subscribed");

  if (subscribed) return;

  const lastShown = localStorage.getItem("subscriptionPopupTime");
  const now = Date.now();
  const twelveHours = 12 * 60 * 60 * 1000;

  if (!lastShown || now - Number(lastShown) > twelveHours) {
    const timer = setTimeout(() => {
      setShowPopup(true);
      localStorage.setItem("subscriptionPopupTime", now.toString());
    }, 10000);

    return () => clearTimeout(timer);
  }
}, []);

  //////////////////////////////////////////////////////
  // INPUT CHANGE
  //////////////////////////////////////////////////////

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  //////////////////////////////////////////////////////
  // SUBMIT
  //////////////////////////////////////////////////////

 const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setLoading(true);

    const payload = {
      email: formData.email,
      phone: `${formData.countryCode}${formData.phone}`,
    };

    const { data } = await axios.post(
      "https://api.clinicalaiassistance.com/api/subscriber/subscribe",
      payload
    );

    if (data.success) {
      alert("Thank you, subscribed successfully 🎉");
      setShowPopup(false);

      localStorage.setItem("subscribed", "true");

      setFormData({
        email: "",
        phone: "",
        countryCode: "+44",
      });
    } else {
      alert(data.message);
    }
  } catch (error) {
    console.log(error.response?.data);
    alert(error.response?.data?.message || "Failed");
  } finally {
    setLoading(false);
  }
};

  return (
    <AnimatePresence>
      {showPopup && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4"
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0, y: 40 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0, y: 40 }}
            className="bg-white rounded-3xl p-8 max-w-md w-full shadow-2xl relative"
          >
            <button
              onClick={() => setShowPopup(false)}
              className="absolute top-4 right-4 text-gray-500 text-xl"
            >
              ✕
            </button>

            <div className="text-center">
              <div className="text-5xl mb-4">📩</div>

              <h2 className="text-2xl font-bold text-[#106EE8]">
                Subscribe Now
              </h2>

              <p className="text-gray-600 mt-3">
                Get updates, free chart reviews and healthcare insights.
              </p>

              <form onSubmit={handleSubmit} className="mt-6 space-y-4">
                <input
                  type="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  className="w-full p-3 rounded-xl border"
                />

                <div className="flex border rounded-xl overflow-hidden">
                  <select
                    name="countryCode"
                    value={formData.countryCode}
                    onChange={handleChange}
                    className="px-3 outline-none"
                  >
                    <option value="+44">🇬🇧 +44</option>
                    <option value="+91">🇮🇳 +91</option>
                    <option value="+1">🇺🇸 +1</option>
                    <option value="+61">🇦🇺 +61</option>
                  </select>

                  <input
                    type="tel"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone number"
                    className="w-full p-3 outline-none"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#106EE8] text-white py-3 rounded-full font-medium"
                >
                  {loading ? "Submitting..." : "Subscribe"}
                </button>
              </form>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SubscriptionPopup;